import excel from './icons/excel_48x1.svg';
import word from './icons/word_48x1.svg';
import powerpoint from './icons/powerpoint_48x1.svg';
import zip from './icons/29119.svg';
import pdf from './icons/Adobe_Acrobat_DC_icon.png';
import image from './icons/ic_photo_black_24px.svg';
import vector from './icons/odg-formato-de-archivo-abierto.svg';
import db from './icons/sasdatabase.svg';
import font from './icons/shapes.png';
import audio from './icons/Speaker_Icon.svg';
import video from './icons/UbuntuStudio-Icons-Video_Production.svg';

let FileTypes = {
    PDFFiles: {
        extensions: ['PDF'],
        icon: pdf
    },
    TextFiles: {
        extensions: ['DOC', 'DOCX', 'LOG', 'MSG', 'ODT', 'PAGES', 'RTF', 'TEX', 'TXT', 'WPD', 'WPS'],
        icon: word
    },
    PresentationFiles: {
        extensions: ['PPS', 'PPT', 'PPTX', 'KEY'],
        icon: powerpoint
    },
    AudioFiles: {
        extensions: ['AIF', 'IFF', 'M3U', 'M4A', 'MID', 'MP3', 'MPA', 'WAV', 'WMA'],
        icon: audio
    },
    VideoFiles: {
        extensions: ['3G2', '3GP', 'ASF', 'AVI', 'FLV', 'M4V', 'MOV', 'MP4', 'MPG', 'RM', 'SRT', 'SWF', 'VOB', 'WMV'],
        icon: video
    },
    ImageFiles: {
        extensions: ['BMP', 'DDS', 'GIF', 'JPG', 'PNG', 'PSD', 'PSPIMAGE', 'TGA', 'THM', 'TIF', 'TIFF', 'YUV'],
        icon: image
    },
    VectorImageFiles: {
        extensions: ['AI', 'EPS', 'PS', 'SVG'],
        icon: vector
    },
    SpreadsheetFiles: {
        extensions: ['CSV', 'XLR', 'XLS', 'XLSX'],
        icon: excel
    },
    DatabaseFiles: {
        extensions: ['ACCDB', 'DB', 'DBF', 'MDB', 'PDB', 'SQL'],
        icon: db
    },
    FontFiles: {
        extensions: ['FNT', 'FON', 'OTF', 'TTF'],
        icon: font
    },
    CompressedFiles: {
        extensions: ['7Z', 'CBR', 'DEB', 'GZ', 'PKG', 'RAR', 'RPM', 'SITX', 'TAR.GZ', 'ZIP', 'ZIPX'],
        icon: zip
    },
};

export function getIconForFileExtension(fileExtension) {
    let icon;
    let found = false;
    let keys = Object.keys(FileTypes);
    for (let i = 0; i < keys.length && !found; i++) {
        let key = keys[i];
        let extensions = FileTypes[key].extensions;
        for (let e = 0; e < extensions.length && !found; e++) {
            let extension = extensions[e];
            if (extension.toLowerCase() === fileExtension.toLowerCase()) {
                icon = FileTypes[key].icon;
            }
        }
    }
    return icon;
}